import { render } from "./reuseStandardDialog.vue?vue&type=template&id=ab1ab224"
import script from "./reuseStandardDialog.vue?vue&type=script&lang=js"
export * from "./reuseStandardDialog.vue?vue&type=script&lang=js"

import "./reuseStandardDialog.vue?vue&type=style&index=0&id=ab1ab224&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__